import styles from '../../styles/index.less';
import animate from '../../styles/animate.less';
import $ from 'jquery';
// import loadingSvg from '../../assets/loading2.png';
// onChange="${this.handlePwdChange}"
// onFocus="${this.handlePwdFocus}"
// onBlur="${this.handlePwdBlur}"
// onClick={this.handleAuth}
function showAuth() {
  this.$passWord = $(`<div class="${styles['auth']} ${styles['full-modal']}">
    <div
      class="${styles['pw-wrapper']} ${animate['animate__animated']} ${animate['animate__bounceInLight']}"
    >
      <p class="${styles['title']}">此项目受密码保护，请输入您的密码：</p>
      <input
        type="password"
        placeholder="请输入密码浏览项目"
        class="${styles['pano-input']}"
      />
      <div class="${styles['btn-group']}">
        <button type="button" class="${styles['pano-btn']}">
          进入项目
        </button>
      </div>
    </div>
  </div>`);

  this.$container.append(this.$passWord);
  this.$passWord.find('input').on('input', this.handlePwdChange.bind(this));
  this.$passWord.find('input').on('focus', this.handlePwdFocus.bind(this));
  this.$passWord.find('input').on('blur', this.handlePwdBlur.bind(this));

  this.$passWord.find('button').on('click', () => {
    this.handleAuth();
  });
}

function handlePwdChange(e) {
  this.pwd = e.target.value;
}

function keyDown(e) {
  if (e.keyCode == 13) {
    this.handleAuth();
  }
}

function handlePwdFocus() {
  window.addEventListener('keydown', this.keyDown.bind(this));
}

function handlePwdBlur() {
  window.removeEventListener('keydown', this.keyDown);
}

function handleAuth() {
  //密码验证事件
  const pwd = this.pwd;
  if (!pwd||this.authIng) return;
  const onCheckPassword = this.props.onCheckPassword;
  if (onCheckPassword && typeof onCheckPassword === 'function') {
    this.authIng = true;
    // this.$passWord.find('button').html(`<img src="${loadingSvg}" class="${styles['rotate-loop']}" width="32" height="32" />`);
    this.props.onCheckPassword(pwd);
  }
}

function authPass() {
  //密码验证通过
  this.$passWord.hide();
  this.authIng = false;
  // this.$passWord.find('button').html(`确定`);
  this.pwd = '';
  this.initPano();
}
function authError() {
  //密码验证失败
  this.authIng = false;
  // this.$passWord.find('button').html(`确定`);
}

export default {
  handlePwdChange,
  keyDown,
  handlePwdFocus,
  handlePwdBlur,
  handleAuth,
  authPass,
  authError,
  showAuth,
};
